import { render } from "./indexView.vue?vue&type=template&id=04da57be"
import script from "./indexView.vue?vue&type=script&lang=js"
export * from "./indexView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__